import React from 'react';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { DealerInfoModel } from 'client/data/models/dealer-info';

export function withCarcodeConfigCheck(WrappedComponent) {
  function CarcodeConfigCheck(props) {
    const { carcodeConfig } = props;
    const isCarcodeEnabled =
      carcodeConfig &&
      (carcodeConfig.isDealerChatActive ||
        carcodeConfig.isFacebookActive ||
        carcodeConfig.isTextActive ||
        carcodeConfig.isEdmundsChatActive) &&
      carcodeConfig.smsNumber;

    return isCarcodeEnabled ? <WrappedComponent {...props} /> : null;
  }

  return connectToModel(CarcodeConfigCheck, {
    carcodeConfig: bindToPath(({ dealerInfo }) => {
      const rooftopId = dealerInfo && dealerInfo.rooftopId;
      return rooftopId ? `carcodeConfig.${rooftopId}` : '';
    }, DealerInfoModel),
  });
}
